<template lang="pug">
v-select.suus__select(
  v-model="selectedOption",
  :items="options",
  item-text="title",
  :item-value="itemValue",
  filled,
  placeholder="Bitte Auswählen...",
  background-color="lightGrey",
  :disabled="disabled",
  max-height="400px",
  :no-data-text="noDataText",
  :no-data="!!noDataText.length"
)
  template(v-slot:label)
    span(:style="labelStyles") {{ label }}
    span(v-if="isMandatory", :style="mandatoryStyles") *

  template(v-slot:selection="data")
    v-row.suus__select-item.mt-4.mb-2(
      v-bind="data.attrs",
      :input-value="data.selectedOption"
    )
      v-col.pl-sm-7(cols="2")
        v-icon(color="primary") {{ checkIcon }}
      v-col(cols="10")
        v-list-item-title.font-weight-bold.pb-4 {{ data.item.title }}
        ItemIconContent(
          v-for="el in data.item.contentItems",
          :key="el.title",
          :icon="el.icon",
          :text="el.text"
        )
  template.suus__select-item(v-slot:item="data")
    v-row(no-gutters, :style="listStyles")
      v-col.pl-sm-7.py-4(cols="2")
        v-icon(:color="setIconColor(data.item.type)") {{ checkIcon }}
      v-col.py-4(cols="10")
        v-list-item-title.font-weight-bold.pb-4 {{ data.item.title }}
        ItemIconContent(
          v-for="el in data.item.contentItems",
          :key="el.title",
          :icon="el.icon",
          :text="el.text"
        )
</template>

<script lang="ts">
import Vue from "vue"
import { mdiCheckCircle } from "@mdi/js"
import ItemIconContent from "../../../app/ui-primitives/forms/ItemIconContent.vue"
import { PropType } from "vue"
import { GroupAccess } from "components/TopicForm/general-fields/group-access"

export type ContentItem = {
  icon: string
  text: string
}

export type ContentfulOption = {
  title: string
  contentItems: ContentItem[]
  type: GroupAccess
}
export default Vue.extend({
  name: "ContentfulSelect",
  components: { ItemIconContent },
  props: {
    isMandatory: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    options: { type: Array as PropType<ContentfulOption[]>, required: true },
    value: { type: String, default: null },
    label: { type: String, required: true },
    noDataText: { type: String, default: "" },
    itemValue: { type: String, default: "title" },
  },
  data() {
    return {
      checkIcon: mdiCheckCircle,
    }
  },
  computed: {
    selectedOption: {
      get(): string {
        return this.value
      },
      set(value: string) {
        this.$emit("input", value)
      },
    },
    labelStyles(): object {
      return {
        color: this.$vuetify.theme.themes.light.primary,
        fontWeight: 400,
      }
    },
    listStyles(): object {
      return {
        borderBottom: `1px solid ${this.$vuetify.theme.themes.light.lightGrey}`,
        fontFamily: "system-ui",
      }
    },
    mandatoryStyles(): object {
      return {
        color: "red",
        fontWeight: 400,
      }
    },
  },
  methods: {
    setIconColor(itemType) {
      if (itemType === this.selectedOption) {
        return "primary"
      }
      return "mediumGrey"
    },
  },
  watch: {
    selectedOption(val: string) {
      this.$emit("input", val)
    },
  },
})
</script>

<style lang="sass">
%font-stack
  font-family: system-ui !important

.suus__select
  @extend %font-stack

  .mandatory
    color: red !important
    font-weight: 900

  .v-list
    padding: 0

  .suus__select-item
    @extend %font-stack
    font-weight: 300
    font-size: 1.2rem !important

  .v-select__selections
    input
      height: 0
</style>
